import { render, staticRenderFns } from "./headBox.vue?vue&type=template&id=7fa7128a&scoped=true&"
import script from "./headBox.vue?vue&type=script&lang=js&"
export * from "./headBox.vue?vue&type=script&lang=js&"
import style0 from "./headBox.vue?vue&type=style&index=0&id=7fa7128a&lang=scss&scoped=true&"
import style1 from "./headBox.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa7128a",
  null
  
)

export default component.exports